import {isChooseMultipleSeatsMode, isChooseSeatMode} from '../../../selectors/navigation'
import {getReservationError} from '../../../selectors/reservation'
import {getFirstPlaceWithDonationError, getSeatingError} from '../../../selectors/seating/errors'
import {getShowPricingOptionsPlace, isInAccessibilityMode} from '../../../selectors/seating/mode'
import {getPlacesInBasket, getSelectedPlace} from '../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {SeatingPlanRuntimeProps} from './interfaces'
import {SeatingPlan as Presentation} from './seating-plan'

const mapRuntime = ({
  state: {
    seating: {loading},
  },
  state,
  actions: {
    setShowAccessibilityMode,
    setPlaceQuantity,
    unselectPlace,
    setSeatingError,
    setShowPlaceDescription,
    clickPlace,
    seatingCheckout,
  },
}: DetailsPageAppProps): SeatingPlanRuntimeProps => ({
  setPlaceQuantity,
  seatingCheckout,
  loading,
  seatingError: getSeatingError(state),
  reservationError: getReservationError(state),
  placesInBasket: getPlacesInBasket(state),
  showAccessibilityMode: isInAccessibilityMode(state),
  chooseSeatMode: isChooseSeatMode(state),
  chooseMultipleSeatsMode: isChooseMultipleSeatsMode(state),
  setShowAccessibilityMode,
  selectedPlace: getSelectedPlace(state),
  clickPlace,
  unselectPlace,
  setSeatingError,
  setShowPlaceDescription,
  showPriceOptionsPlace: getShowPricingOptionsPlace(state),
  firstPlaceIdWithError: getFirstPlaceWithDonationError(state)?.id,
})

export default connect<{}, SeatingPlanRuntimeProps>(mapRuntime)(Presentation)
